import { EngagementsState } from '../state/engagementsState';
import { AppAction } from '../actions/appAction';
import produce from 'immer';

const unloaded: EngagementsState = {
	details: new Map()
};

export default function engagementsReducer(state: EngagementsState | undefined = unloaded, action: AppAction): EngagementsState {
	switch (action.type) {
		case 'engagements/details-loaded':
			return produce(state, draft => {
				draft.details.set(action.id, action.engagement);
			});
		default:
			return state;
	}
}